import { memo } from "react";
import { Flex } from "../flex";
import {
  BgColorValue,
  OverflowValue,
  SpacingValue,
  WidthValue,
} from "../theme/box";

export const FormSidePanel = memo(function SidePanel({
  children,
  className,
  side,
  fixedWidth,
  width,
  flex,
  overflowY = "auto",
  bgColor = "secondary",
  pb,
  hideScrollbar = false,
}: {
  children?: React.ReactNode;
  className?: string;
  side: "left" | "right";
  /**
   * Fixed pixel width applied as an inline style. Prefer `width` (token-based)
   * when the desired width matches a `WidthValue` token.
   */
  fixedWidth?: number | string;
  /**
   * Token-based fixed width. Renders as a class (no inline style) and pins the
   * panel so it neither grows nor shrinks as the page is resized.
   */
  width?: WidthValue;
  flex?: number;
  overflowY?: OverflowValue;
  bgColor?: BgColorValue;
  pb?: SpacingValue;
  hideScrollbar?: boolean;
}) {
  return (
    <Flex
      bgColor={bgColor}
      borderColor="primary"
      borderLeftWidth={side === "right" ? "1px" : "none"}
      borderRightWidth={side === "left" ? "1px" : "none"}
      borderStyle="solid"
      className={className}
      dir="column"
      flex={width ? undefined : flex}
      overflowY={overflowY}
      pb={pb}
      // Keeps side panel from overflowing the page inspector
      position="relative"
      shrink={width ? "0" : undefined}
      style={{
        ...(fixedWidth
          ? {
              flex: "none",
              width:
                typeof fixedWidth === "number" ? `${fixedWidth}px` : fixedWidth,
            }
          : {}),
        ...(hideScrollbar ? { scrollbarWidth: "none" as const } : {}),
      }}
      w={width ?? "full"}
    >
      {children}
    </Flex>
  );
});
